/**
 * AmountItemConfig
 *  Encapsulates amount item configuration settings.
 * */
var AmountItemConfig = /** @class */ (function () {
    /**
     * Create a new amount item configuration.
     * @param computation Amount computation method.
     * @param rules VeeValidate rule object.
     */
    function AmountItemConfig(computation, rules) {
        if (computation === void 0) { computation = null; }
        if (rules === void 0) { rules = {}; }
        this._computation = computation;
        this._rules = rules;
    }
    Object.defineProperty(AmountItemConfig.prototype, "computation", {
        get: function () {
            return this._computation;
        },
        set: function (comp) {
            this._computation = comp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmountItemConfig.prototype, "rules", {
        get: function () {
            return this._rules;
        },
        set: function (rules) {
            this._rules = rules;
        },
        enumerable: false,
        configurable: true
    });
    return AmountItemConfig;
}());
export default AmountItemConfig;
